(function () {
  'use strict';

  /* global FormData */
  class ImportacaoMotoristaCtrl {
    constructor(Uos, Flash, $scope, HttpServiceV3g) {
      this.uoService = Uos;
      this.flash = Flash;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.uos = [];
      this.uo = {};
      this.files = [];
      this.loadUos();

      this.scope.uploadedFile = (element) => {
        this.scope.$apply((scope) => {
          scope.files = element.files;
        });
      };
    }

    loadUos() {
      this.uoService.getFilhasLista().then(data => {
        this.uos = data.plain();
      });
    }

    importar() {
      var formData = new FormData();
      this.clearMensagens();
      formData.append('file', this.scope.files[0]);
      formData.append('uoId', this.uo.id);

      this.httpService.post('/motorista/motoristas/importar-csv', formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success((data) => {
          if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            this.msgSucessoComErro = data;
          } else {
            this.msgSucesso = 'Importação de motoristas realizada com sucesso!';
          }
        })
        .error((data) => {
          if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            this.flash.create('error', data.mensagens[0]);
          } else {
            this.flash.create('error', 'Erro ao importar os motoristas.');
          }
        });
    }

    clearMensagens() {
      this.msgErro = null;
      this.msgSucesso = null;
      this.msgSucessoComErro = null;
    }
  }

  /**
   * @ngdoc object
   * @name importacaoMotorista.controller:ImportacaoMotoristaCtrl
   *
   * @description
   *
   */
  angular
    .module('importacaoMotorista')
    .controller('ImportacaoMotoristaCtrl', ImportacaoMotoristaCtrl);
}());
